import { toast } from "react-toastify";

export function errorResponseHelper(err: any) {
    
    toast.error(err.response.data.message || err.response.data || "Something Went Wrong");
    return false
}